import { Controller } from "@hotwired/stimulus"
import { DebounceHelper } from "~/helpers/debounce_helper"
import "@selectize/selectize"

export default class extends Controller {
  static targets = [
    "bccRecipient",
    "emailAccountSelect",
    "unsubscribeFooter",
    "unsubscribeCheckbox",
    "trackCheckbox",
    "trackLinksCheckbox",
    "saveLoader",
    "saveMessage",
    "errorMessage",
    "bccFieldContainer",
    "bccRecipientLink",
  ]

  static values = { campaignId: Number }

  connect() {
    let _this = this

    if (
      this.hasEmailAccountSelectTarget &&
      this.emailAccountSelectTarget.tagName === "SELECT" &&
      this.emailAccountSelectTarget.classList.contains("h-selectize")
    ) {
      this.emailAccountSelectize = $(this.emailAccountSelectTarget).selectize({
        plugins: ["remove_button"],
        create: true,
        onOptionAdd: function () {
          Turbo.visit("/campaigns/settings?tab=email-accounts")
        },
        onChange: () => {
          _this.save()
        },
        render: {
          option_create: function (data, escape) {
            return `<div class="create">${i18n.t("js.add")} <strong>${escape(data.input)}</strong>&hellip;</div>`
          },
        },
      })
    }

    if (this.hasBccRecipientTarget) {
      this.bccRecipientTarget.addEventListener(
        "keyup",
        DebounceHelper.debounce(function () {
          _this.save()
        }, 2000),
      )
    }

    if (this.hasSaveLoaderTarget) {
      this.saveLoaderTarget.addEventListener("save-message", (event) => {
        const target = event.detail.target

        if (target === "saveLoader") {
          this.showSaveMessage()
        } else if (target === "savedMessage") {
          this.showSaveMessage()
        } else if (target === "errorMessage") {
          this.showErrorMessage(event.detail.error)
        }
      })
    }
  }

  disconnect() {
    // Destroy the Selectize element to avoid duplication of the field
    if (this.hasEmailAccountSelectTarget && this.emailAccountSelectize !== undefined) {
      this.emailAccountSelectize[0].selectize.destroy()
    }
  }

  save() {
    if (
      this.hasBccRecipientTarget &&
      this.bccRecipientTarget.value !== "" &&
      App.validateEmail(this.bccRecipientTarget.value) === false
    ) {
      App.displayFlash("danger", i18n.t("js.back.campaigns.content.invalid_bcc_email"))
      this.showErrorMessage()
      return
    }

    this.showLoader()

    let emailAccountIds

    if (this.hasEmailAccountSelectTarget && this.emailAccountSelectTarget.tagName === "SELECT") {
      emailAccountIds = Array.from(this.emailAccountSelectTarget.selectedOptions).map((option) => option.value)
    } else if (this.hasEmailAccountSelectTarget && this.emailAccountSelectTarget.tagName === "INPUT") {
      emailAccountIds = [this.emailAccountSelectTarget.value]
    }

    fetch(`/campaigns/${this.campaignIdValue}`, {
      method: "PUT",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
      body: JSON.stringify({
        campaign: {
          add_unsubscribe_link: this.unsubscribeCheckboxTarget.checked,
          email_account_ids: emailAccountIds,
          tracked: this.hasTrackCheckboxTarget ? this.trackCheckboxTarget.checked : "",
          tracked_links: this.hasTrackLinksCheckboxTarget ? this.trackLinksCheckboxTarget.checked : "",
          bcc_recipient: this.hasBccRecipientTarget ? this.bccRecipientTarget.value : "",
        },
      }),
    }).then((response) => {
      if (response.ok) {
        return this.showSaveMessage()
      }
      this.showErrorMessage()
    })
  }

  toggleBccField() {
    var _this = this

    $(this.bccFieldContainerTarget).toggleClass("d-none")

    if ($(_this.bccFieldContainerTarget).is(":hidden")) {
      _this.bccRecipientTarget.value = ""
      _this.bccRecipientLinkTarget.innerHTML = i18n.t("js.back.campaigns.content.add_bcc_recipient")
      _this.save()
    } else {
      _this.bccRecipientLinkTarget.innerHTML = i18n.t("js.back.campaigns.content.remove_bcc_recipient")
    }
  }

  showLoader() {
    App.hideFlash()

    $(this.saveMessageTargets).hide()
    $(this.errorMessageTargets).hide()
    $(this.saveLoaderTargets).show()
  }

  showSaveMessage() {
    $(this.saveLoaderTargets).hide()
    $(this.errorMessageTargets).hide()
    $(this.saveMessageTargets).show()
  }

  showErrorMessage() {
    $(this.saveLoaderTargets).hide()
    $(this.saveMessageTargets).hide()
    $(this.errorMessageTargets).show()
  }

  toggleUnsubscription() {
    $(this.unsubscribeFooterTargets).toggle()
    this.save()
  }
}
